<template>
<div class="chapter">
<div class="inner_page">
<div id="Frontmatter">
<p class="fm-para1">By the same author</p>
<p class="fm-para2"><i>The Spice of Flight</i></p>
<p class="fm-para2"><i>Flying the Waves</i></p>
<p class="fm-para2"><i>Beaufighter Ace</i></p>
<p class="fm-para2"><i>Seven Seas, Nine Lives</i></p>
<p class="fm-para2"><i>Moose’s War</i></p>
<p class="fm-para2"><i>The Lightning Boys</i></p>
<p class="fm-para2"><i>Alfie’s War</i></p>
<p class="fm-para2"><i>The Lightning Boys 2</i></p>
<p class="fm-para2"><i>Hunter Boys</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Frontmatter.vue?128a8c85